import SuccessIcon from "../../../images/success.inline.svg";
import React from "react";
import { css } from "@emotion/react";
import { mql } from "../../../styles/breakpoints";
import styled from "@emotion/styled";

const success = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const successIcon = css`
  width: 100px;
  height: 100px;

  ${ mql.md } {
    width: 130px;
    height: 130px;
  }
`;

const H2 = styled.h2`
  font-family: ObjectSans, SFProDisplay, sans-serif;
  font-weight: 800;
  font-size: 24px;
  text-align: center;

  ${ mql.md } {
    font-size: 28px;
  }
`;

export const Success = () => {
  return <div css={ success }>
    <SuccessIcon css={ successIcon }/>
    <H2>Спасибо! Мы ответим вам в течение одного рабочего дня.</H2>
  </div>;
};